import axiosTokenInstance from 'services/api/backoffice';
import { CONSULTINGCHECKIMEI, CONSULTINGCHECKIMEI_ERROR } from '_models/redux/types';

// Action function
export const consultingChCheckImei = (params) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(`/api/clients/imei/${params}/status`);

    const { data, status } = response || {};

    dispatch({
      type: CONSULTINGCHECKIMEI,
      payload: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: CONSULTINGCHECKIMEI_ERROR,
      payload: e || {},
    });
  }
};
